import { useApi } from "../../api/hooks/use-api.ts";
import { ApiMethod } from "../../api/types.ts";
import { withObjectPayload } from "../../api/payload.ts";

export const useVerificationApi = () => {
    const { sendProtectedRequest } = useApi();

    // OK: payload is { success, order_ids }. 400: { success: false, errors }.
    const postVerification = async (verification) => {
        const response = sendProtectedRequest(ApiMethod.POST, process.env.REACT_APP_FPSB_PORTAL_REQUEST_ENDPOINT + '&token=' + process.env.REACT_APP_FPSB_PORTAL_TOKEN + '&action=verification', verification);

        return response.then(withObjectPayload);
    };

    return { postVerification };
};
